module.exports = __webpack_public_path__ + "img/horizontal_7_2_5012.beac80f0.png";